import React, { useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { DialogProps } from "@material-ui/core/Dialog";
import RefreshIcon from "@material-ui/icons/Refresh";
import CloseIcon from "@material-ui/icons/Close";

import { store } from "@store";
import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";

import RegularButton from "@components/buttons/RegularButton";
import { makeStyles } from "@material-ui/core/styles";

type Props = DialogProps & {
  source: string;
  withSkip?: boolean;
};

export function ImageCropperDialog(props: Props) {
  const [cropper, setCropper] = useState(undefined);

  const onClose = () => {
    store().upload.imageCropperDialogClose();
  };

  const handleSubmit = () => {
    const result = cropper.getCroppedCanvas().toDataURL();
    store().upload.imageCropperDialogSubmit(result);
  };

  const handleSkip = () => {
    store().upload.imageCropperDialogSubmit(props.source);
  };

  const handleRotate = (clockwise: boolean) => {
    const rotationAngle = clockwise ? 45 : -45;
    cropper.rotate(rotationAngle);
  };

  const classes = useStyles({});
  const { open, source, ...rest } = props;

  return (
    <Dialog
      open={open}
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
      fullWidth
      {...rest}
    >
      <DialogTitle className={classes.title}>
        {locale["Crop the photo"]}
        <CloseIcon onClick={onClose} className={classes.closeIcon} />
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Cropper
          ref={(c) => {
            setCropper(c);
          }}
          src={source as any}
          style={{ height: 400, width: "100%" }}
          aspectRatio={1}
          guides
        />
      </DialogContent>

      <DialogActions style={{ justifyContent: "space-between" }}>
        <div>
          <RegularButton
            leftIcon={<RefreshIcon />}
            onClick={() => handleRotate(false)}
            variant="text"
            style={{ marginRight: 10, transform: "scaleX(-1)" }}
          />
          <RegularButton
            leftIcon={<RefreshIcon />}
            onClick={() => handleRotate(true)}
            variant="text"
          />
        </div>
        <div>
          {props.withSkip && (
            <RegularButton
              onClick={handleSkip}
              variant="text"
              style={{ marginRight: 10 }}
            >
              {locale["Upload Original"]}
            </RegularButton>
          )}

          <RegularButton onClick={handleSubmit} variant="text">
            {locale["Crop and Upload"]}
          </RegularButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  title: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    borderBottomColor: theme.palette.common.black,
    borderBottomWidth: 2,
    "& > *": {
      color: "inherit",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  },

  closeIcon: {
    cursor: "pointer"
  },

  content: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    borderColor: theme.palette.common.black,
    borderWidth: 2
  },

  controls: {
    backgroundColor: theme.palette.common.white,
    display: "flex",
    justifyContent: "space-evenly",
    padding: theme.spacing()
  }
}));
